import { createSlice, current } from "@reduxjs/toolkit";
import { beneficiaryAdded, beneficiaryRemoved, } from "store/reducers/dashboard/benificiaries";
import { ID_DOC_TYPE, PROOF_OF_ADDRESS_TYPE } from "shared/enums/DocumentsTypes";

// JDD (proof_of_address) is only mandatory for Riverbank; that's checked separately
// (see hasRiverbankProvider) wherever this flag is consumed. This flag only reflects
// the always-mandatory identity document.
const moreUploadNeeded = (docs) => {
  const beneficiaryWithEmptyDocs = Object.keys(docs).find(
    (k) => {
      return docs[k].filter((e) => ID_DOC_TYPE.includes(e.document_type)).length === 0
    }
  );
  return beneficiaryWithEmptyDocs !== undefined;
};

const slice = createSlice({
  name: "beneficiaries",
  initialState: {
    docs: {
      //beneficiary_id: id_docs: [],
    },
    moreUploadNeeded: false,
  },
  reducers: {},
  extraReducers: {
    initDashboard: (state, { payload }) => {
      //create empty list for each beneficiary
      if (payload.ultimate_beneficiary_owners) {
        payload.ultimate_beneficiary_owners.forEach(
          (x) => (state.docs[x.id] = [])
        );
      }

      //fill beneficiary list of docs
      if (payload.documents) {
        payload.documents.forEach((doc) => {
          if (
            doc.owner_type.toLowerCase() === "ultimatebeneficiary" &&
            (ID_DOC_TYPE + PROOF_OF_ADDRESS_TYPE).includes(doc.document_type) &&
            doc.owner_id
          ) {
            //TODO: ce n'est pas bon nous allons avoir les id des deux type d'interlocuteurs!
            if (!state.docs[doc.owner_id]) state.docs[doc.owner_id] = [];
            state.docs[doc.owner_id].push(doc);
          }
        });
      }
      state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
    },
    documentUploaded: (state, { payload }) => {
      if (payload.folder === "ultimate_beneficiary_owners") {
        state.docs[payload.owner_id].push(payload);
        state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
      }
    },
    documentDeleted: (state, { payload }) => {
      if (payload.folder === "ultimate_beneficiary_owners") {
        state.docs[payload.owner_id] = state.docs[payload.owner_id].filter(
          (x) => x.id !== payload.id
        );
        state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
      }
    },
    [beneficiaryAdded.type]: (state, { payload }) => {
      state.docs[payload.id] = [];
      state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
    },
    [beneficiaryRemoved.type]: (state, { payload }) => {
      delete state.docs[payload.id];
      state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
    },
  },
});

export const { documentUploaded } = slice.actions;
export default slice.reducer;
